import type { ReactNode } from "react";

import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import theme from "~/themes/theme";

interface AppThemeProviderProps {
	children: ReactNode;
}

/** Mounts the single MUI theme plus a CSS baseline reset for the whole app. */
const AppThemeProvider = ({ children }: AppThemeProviderProps) => (
	<ThemeProvider theme={theme}>
		<CssBaseline />
		{children}
	</ThemeProvider>
);

export default AppThemeProvider;
